<template>
  <div class="h-dvh flex flex-col overflow-hidden">
    <!-- The dark navbar is the chrome everywhere; the verification nudge sits
         under it so the chrome stays the top edge. The create-video editor is
         full-bleed below: it fills the viewport and scrolls its own panels, so
         the page must not scroll behind it. -->
    <TopBar />
    <EmailVerificationBanner />
    <div
      class="flex-1 min-h-0"
      :class="fullBleed ? 'flex flex-col overflow-hidden' : 'overflow-y-auto overflow-x-hidden'"
    >
      <router-view />
    </div>

    <!-- One look for every toast (the alerts redesign): a white card, the tone
         in its icon chip (ToastIcons.ts, style.css). Timings: utils/toast.ts. -->
    <Toaster close-button :duration="5000" :visible-toasts="3" position="bottom-right">
      <template #success-icon><component :is="TOAST_ICONS.success" /></template>
      <template #error-icon><component :is="TOAST_ICONS.error" /></template>
      <template #warning-icon><component :is="TOAST_ICONS.warning" /></template>
      <template #info-icon><component :is="TOAST_ICONS.info" /></template>
      <template #close-icon><component :is="TOAST_ICONS.close" /></template>
    </Toaster>
    <AccountSettingsModal v-if="authStore.isAuthenticated" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import EmailVerificationBanner from '@/components/EmailVerificationBanner.vue'
import TopBar from '@/components/TopBar.vue'
import AccountSettingsModal from '@/components/AccountSettingsModal.vue'
import { Toaster } from 'vue-sonner'
import { TOAST_ICONS } from '@/components/ToastIcons'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const authStore = useAuthStore()

const fullBleed = computed(() => route.meta.fullBleed === true)
</script>
